
export class PlantAccess {
  userId?: number;
  plantId?: number;
  plantName?: string;
  country?: string;
  regions?: Array<string>;
}
